var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"close-on-content-click":false,"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(!_vm.user)?_c('v-btn',_vm._g(_vm._b({attrs:{"rounded":"","outlined":"","text":"","size":"35","loading":_vm.loading}},'v-btn',attrs,false),on),[_c('span',{staticClass:"mr-2"},[_vm._v("Log in")])]):_vm._e()]}}])},[_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"344","outlined":""}},[_c('login')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }